import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9289ba06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order" }
const _hoisted_2 = { class: "order-title" }
const _hoisted_3 = { class: "order-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "order-item-icon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "red-dot"
}
const _hoisted_8 = { class: "order-item-name" }

import { ref, watch, watchEffect, Ref } from 'vue'
import { t } from '@/plugins/i18n'
import { useRtfix, isD2C, isJA } from '@/store'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import { DeliveryAbnormalOrderCount } from '@/apis/interface/customer'
import { useRouter } from 'vue-router'

enum ENUM_ORDER_TYPE {
    /** 待付款 */
    PENGING_PAYMENT = '2',
    /** 处理中 */
    PROCESSING = '4',
    /** 待发货 */
    PENDING_DELIVERY = '8',
    /** 部分发货 */
    PART_DELIVERY = '16',
    /** 已发货 */
    SHIPPED = '32',
    /** 取消商品 */
    CANCELLED = '12',
    /** 已完成 */
    COMPLETED = '32',
}

export interface OrderTypeItem {
  name?: string
  value?: string
  icon?: string;
  num?: string | number;
  orderStatus: string;
  position?: string;
  path?: string;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    workbenchOrderInfo: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as {
    workbenchOrderInfo: DeliveryAbnormalOrderCount
}
const orderTypeList2C: OrderTypeItem[] = [
  {
    name: t('待付款'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/待支付.svg',
    num: 0,
    orderStatus: ENUM_ORDER_TYPE.PENGING_PAYMENT,
    position: 'my_order_to_be_paid'
  },
  {
    name: t('处理中'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/处理中.svg',
    num: 0,
    orderStatus: ENUM_ORDER_TYPE.PROCESSING,
    position: 'my_order_processing'
  },
  {
    name: t('待发货'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/待发货.svg',
    num: 0,
    orderStatus: ENUM_ORDER_TYPE.PENDING_DELIVERY,
    position: 'my_order_to_be_shipped'
  },
  {
    name: t('部分发货'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/部分发货.svg',
    num: 0,
    orderStatus: ENUM_ORDER_TYPE.PART_DELIVERY,
    position: 'my_order_partial_shipment'
  },
  {
    name: t('已完成'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/已完成.svg',
    num: 0,
    orderStatus: ENUM_ORDER_TYPE.SHIPPED,
    position: 'my_order_complete'
  },
  {
    name: t('取消商品'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/取消商品.svg',
    num: 0,
    orderStatus: ENUM_ORDER_TYPE.CANCELLED,
    position: 'my_order_cancel'
  }
]

const orderTypeList2B:OrderTypeItem[] = [
  {
    name: t('待付款'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/待支付.svg',
    num: 0,
    orderStatus: ENUM_ORDER_TYPE.PENGING_PAYMENT,
    position: 'my_order_to_be_paid'
  },
  {
    name: t('处理中'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/处理中.svg',
    num: 0,
    orderStatus: ENUM_ORDER_TYPE.PROCESSING,
    position: 'my_order_to_be_paid'
  },
  {
    name: t('已完成'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/已完成.svg',
    num: 0,
    orderStatus: ENUM_ORDER_TYPE.COMPLETED,
    position: 'my_order_to_be_shipped'
  },
  {
    name: t('取消商品'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/取消商品.svg',
    num: 0,
    orderStatus: ENUM_ORDER_TYPE.CANCELLED,
    position: 'my_order_cancel'
  }
]
const orderTypeList: Ref<OrderTypeItem[]> = ref(isD2C() ? orderTypeList2C : orderTypeList2B)



watchEffect(() => {
  const newArr = [...orderTypeList.value]
  newArr.map((item) => {
    if (item.orderStatus === ENUM_ORDER_TYPE.PENGING_PAYMENT) {
      item.num = props?.workbenchOrderInfo?.waitPayOrderCount || 0
    } else if (item.orderStatus === ENUM_ORDER_TYPE.PROCESSING) {
      item.num = props.workbenchOrderInfo?.dealOrderCount || 0
    } else if (item.orderStatus === ENUM_ORDER_TYPE.PENDING_DELIVERY) {
      item.num = props.workbenchOrderInfo?.canDeliveryOrderCount || 0
    } else if (item.orderStatus === ENUM_ORDER_TYPE.PART_DELIVERY) {
      item.num = props.workbenchOrderInfo?.partDeliveryOrderCount || 0
    } else if (item.orderStatus === ENUM_ORDER_TYPE.SHIPPED) {
      item.num = props.workbenchOrderInfo?.completeOrderCount || 0
    } else if (item.orderStatus === ENUM_ORDER_TYPE.CANCELLED) {
      item.num = props.workbenchOrderInfo?.canceledCount || 0
    }
  })
})

const router = useRouter()
/** 跳转页面 */
const handleAppLink = (item: OrderTypeItem) => {
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: { position: item.position }
  })
  if (item.orderStatus === ENUM_ORDER_TYPE.CANCELLED) {
    return router.push(useRtfix('AbnormalOrder', { query: { abnormal: 'ApplyCancel' } }))
  }
  return router.push(useRtfix('OrderList', { query: { platformOrderStatus: item.orderStatus } }))
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('我的订单')), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderTypeList.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "order-item",
          key: item.orderStatus,
          onClick: ($event: any) => (handleAppLink(item))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: item.icon,
              width: "28",
              height: "28"
            }, null, 8, _hoisted_6),
            (Number(item?.num) > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["order-item-num", Number(item?.num) > 0 ? 'is-red': ''])
          }, _toDisplayString(item.num), 3),
          _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1)
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})